module.exports = __webpack_public_path__ + "img/contents-1@3x.0a0651a2.png";